import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-5 flex justify-between text-grey items-center"
}
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "h-12 w-12 min-w-[48px] min-h-[48px] rounded-full flex justify-center items-center border-2 bg-greyLight text-grey text-xl" }
const _hoisted_4 = { class: "ml-4" }
const _hoisted_5 = { class: "font-medium flex space-x-2 items-center" }
const _hoisted_6 = { "data-cy": "userName" }
const _hoisted_7 = { "data-cy": "userPhone" }
const _hoisted_8 = { class: "flex flex-col items-center m-4 mb-1 z-10 text-[#ec5f59] text-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_info_skeleton = _resolveComponent("user-info-skeleton")!
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    (_ctx.userData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.userData.full_name ? _ctx.userData.full_name.charAt(0) : ""), 1),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.userData.full_name), 1)
              ]),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.userData.phone_number), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "bg-[#ec5f59] border border-[#ae3d39] animate-pulse leading-3 text-xs text-white rounded-sm flex justify-center items-center text-center px-2 py-1 cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('handleClick')))
            }, [...(_cache[1] || (_cache[1] = [
              _createTextVNode(" Связаться", -1),
              _createElementVNode("br", null, null, -1),
              _createTextVNode("c «Парком» ", -1)
            ]))])
          ])
        ]))
      : (_openBlock(), _createBlock(_component_user_info_skeleton, { key: 1 }))
  ])), [
    [_directive_auto_animate]
  ])
}